import Home from "@/pages/Home";
import "./App.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Search from "@/pages/Search";
import { useEffect, useState } from "react";
import { setSessionStorage } from "@/helpers/handleSessionStorage";

const queryClient = new QueryClient();

const App = () => {

  const [searchSubmitted, setSearchSubmitted] = useState(window.location.href.includes("?q="));
  const [count, setCount] = useState(0);
  const hideLoader = () => {
    const element = document.getElementById("syf-loader-home");
    if(element) {
      element.style.display = "none";
    }
  }

  const handlePop = (event?: any) => {
    if(window.location.href.includes("?q=")) {
      setSearchSubmitted(true);
      setCount(count => count + 1);
    } else {
      setSearchSubmitted(false);
    }
  }

  useEffect(() => {
    window.addEventListener('popstate', handlePop);
  },[])

  hideLoader();
   if(retailCategoriesDetails != undefined) {
      setSessionStorage("category", window.retailCategoriesDetails);
    }

  const handleSearchSubmit = (query: boolean) => {
    setSearchSubmitted(query);
  };

  return (
    <QueryClientProvider client={queryClient}>
       {searchSubmitted ?
    (<Search count={count}  onSearchSubmit={handleSearchSubmit} />) : (<Home onSearchSubmit={handleSearchSubmit} />)}
    </QueryClientProvider>

  );
}

export default App;
